import React from 'react';

import { ListItem } from 'material-ui/List';

import ClearButton from './ClearButton';

import { m } from '../../../utils';
import styles from '../../../styles';

const SingleShift = ({
  shift = {},
  removeFromSelectedShifts = () => {}
}) => (
  <div
    className="col-sm-6"
    style={{
      paddingRight: '0.5%',
      paddingLeft: '0.5%',
      paddingBottom: '1%'
    }}>
    <ListItem
      primaryText={
        <div style={{ overflow: 'hidden', display: 'flex' }}>
          <div style={styles.paddingZero}>
            <div style={styles.noWrap}>
              {m(shift.startTime).format('LL')}
            </div>{' '}
            <div style={styles.noWrap}>
              | {m(shift.startTime).format('ha')} -{' '}
              {m(shift.endTime).format('ha')}
            </div>{' '}
            <div style={styles.noWrap}>| {shift.parkinglot}</div>{' '}
            <div style={styles.noWrap}>| Autzu {shift.vehicleClass}</div>
          </div>
          <ClearButton
            handleClick={() => removeFromSelectedShifts(shift)}
            style={{
              alignSelf: 'center',
              marginLeft: 'auto',
              marginRight: 0
            }}
          />
        </div>
      }
      style={styles.listItem}
    />
  </div>
);

export default SingleShift;



// WEBPACK FOOTER //
// ./src/components/Book/SelectedShifts/SingleShift.js